module.exports = __webpack_public_path__ + "img/headphone.8bd73d93.svg";